module.exports = __webpack_public_path__ + "img/u4673.055e0dce.svg";